export const seriesInfoConfig: {
  [modalityId: string]: { description: string; title: string; tag: string }[]
} = {
  CT: [
    {
      description: 'series description ',
      title: 'Desc',
      tag: 'SeriesDescription',
    },
    { description: 'thickness ', title: 'Thick', tag: 'SliceThickness' },
    { description: 'kvp ', title: 'kVp', tag: 'KVP' },
    { description: 'mas ', title: 'mAs', tag: 'XRayTubeCurrent' },
    { description: 'FOV ', title: 'FOV', tag: 'ReconstructionDiameter' },
  ],
  MR: [
    {
      description: 'series description',
      title: 'Desc',
      tag: 'SeriesDescription',
    },
    { description: 'thickness', title: 'Thick', tag: 'SliceThickness' },
    { description: 'TR', title: 'TR', tag: 'RepetitionTime' },
    { description: 'TE', title: 'TE', tag: 'EchoTime' },
    { description: 'coil', title: 'Coil', tag: 'TransmitCoilName' },
  ],
  MG: [
    {
      description: 'presentation intent type',
      title: 'type',
      tag: 'PresentationIntentType',
    },
    { description: 'kvp', title: 'KVP', tag: 'KVP' },
    // mAs is the Exposure tag (0018,1152). XRayTubeCurrent (0018,1151) is tube
    // current in mA -- labelling it "mAs" made the viewer disagree with the
    // SDNR chart for the same image.
    { description: 'mas', title: 'mAs', tag: 'Exposure' },
    { description: 'filter', title: 'Filter', tag: 'FilterType' },
    { description: 'anode', title: 'Anode', tag: 'AnodeTargetMaterial' },
  ],
}
